import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type ReadContentV3Params = OpalApiRequestParams<'ReadContentV3'>
type ReadContentV3Response = OpalApiResponseDocument<'ReadContentV3', 200>

export const readContent = async ({
  path,
  query,
}: ReadContentV3Params): Promise<ReadContentV3Response> => {
  const contentId = path.content_id
  const url = new URL(`/content/v3/${contentId}`, window.location.origin)

  url.search = queryString({
    'expose[meta][access]': String(!!query.expose?.meta?.access),
  })

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
